import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { isNotNullable } from 'haba-core';
import { CurrentProductService } from 'haba-storefrontlib';
import { Observable } from 'rxjs';
import { filter, pluck, take } from 'rxjs/operators';
import { AvailabilityTrafficLightItem } from 'src/app/@types/product';
import { AvailabilityComponent } from '../../availability/availability.component';

@Component({
  selector: 'app-stock-information',
  templateUrl: './stock-information.component.html',
  styleUrls: ['./stock-information.component.scss'],
  imports: [NgIf, AvailabilityComponent, AsyncPipe],
})
export class StockInformationComponent implements OnInit {
  public availability$: Observable<AvailabilityTrafficLightItem>;

  constructor(private currentProductService: CurrentProductService) {}

  ngOnInit(): void {
    this.availability$ = this.currentProductService
      .getProduct()
      .pipe(filter(isNotNullable), take(1), pluck('availabilityTrafficLight'));
  }
}
